<template>
  <div v-if="props.tipoServicio && props.idEmpresaServicios"
    class="container-fluid px-4 rounded-4 contenedor-principal">
    <div class="toolbar-anexo d-flex flex-wrap align-items-center justify-content-between mb-3">
      <navegar-atras :ruta="rutaGestion"></navegar-atras>
      <DxButton v-bind="{ ...saveButtonProps() }" @click="onGuardar" />
    </div>    
    <div v-if="formReady" class="bg-white p-3 rounded-4">
      <anexo-empresa-servicios-form
        ref="formRef"
        :key="formKey"
        :detail="detailModel"
        :id-empresa-servicios="props.idEmpresaServicios"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import NavegarAtras from "@/components/NavegarAtras.vue";
import AnexoEmpresaServiciosForm from "@/components/empresas-servicios/energia/AnexoEmpresaServiciosForm.vue";
import { useApi } from "@api/integration";
import { useRouter } from "@services/routing-services";
import { type AnexoEmpresaServiciosDetailDto } from "@api/api";

import { DxButton } from "devextreme-vue";
import { saveButtonProps } from "@/.shared/helpers/button-helper";

const props = defineProps<{
  tipoServicio: string;
  idEmpresaServicios: string;
  idAnexo: string | null;
}>();

const api = useApi();
const router = useRouter();
const formRef = ref<InstanceType<typeof AnexoEmpresaServiciosForm>>();
const detailModel = ref<AnexoEmpresaServiciosDetailDto | null>(null);

const rutaGestion = computed(() => `/empresas-servicios/${props.tipoServicio}/${props.idEmpresaServicios}`);

const formKey = computed(() => props.idAnexo ?? "nuevo");

const formReady = computed(() => !props.idAnexo || detailModel.value != null);

watch(
  () => props.idAnexo,
  async (id) => {
    if (!id) {
      detailModel.value = null;
      return;
    }
    detailModel.value = await api.callStandardApi("getAnexoEmpresaServiciosById", { showLoading: true }, id);
  },
  { immediate: true }
);

async function onGuardar() {
  const result = await formRef.value!.guardar();

  if (!result.success) {
    return;
  }

  if (result.newId) {
    await router.replace({
      name: "empresa-servicios-anexo",
      params: {
        tipoServicio: props.tipoServicio,
        idEmpresaServicios: props.idEmpresaServicios,
      },
      query: { id: result.newId },
    });
  }
}
</script>

<style lang="scss" scoped>
.toolbar-anexo :deep(.navigateToBack) {
  margin-bottom: 0;
}
</style>
